import React, { useCallback } from 'react'
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom'
import { Tab, Box } from '@mui/material'
import { TabContext, TabList } from '@mui/lab'
import { useTranslation } from 'react-i18next'

const tabs = [
  { value: 'business', route: '/business' },
  { value: 'playlists', route: '/business/playlists' },
]
export const tabHiddenRoutes = [
  '/learning-path/',
  '/playlist-details/',
  '/playlist/content/',
]
const BusinessLayout: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const matchTabFromPath = useCallback(() => {
    if (location.pathname.includes('/playlist')) return 'playlists'
    if (location.pathname.includes('/business')) return 'business'
    return tabs[0].value
  }, [location.pathname])

  const onTabChange = (
    _event: React.SyntheticEvent,
    newValue: (typeof tabs)[number]['value']
  ) => {
    const tab = tabs.find((tab) => tab.value === newValue)
    if (tab) {
      navigate(tab.route)
    }
  }

  const shouldHideTabs = tabHiddenRoutes.some((path) =>
    location.pathname.includes(path)
  )

  const selectedTabKey = matchTabFromPath()

  return (
    <>
      {!shouldHideTabs && (
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            marginBottom: 2,
            marginTop: 0,
          }}
        >
          <TabContext value={selectedTabKey}>
            <TabList
              textColor="primary"
              variant="scrollable"
              scrollButtons={false}
              onChange={onTabChange}
              value={selectedTabKey}
            >
              <Tab
                key="business"
                label={t('Business.Tabs.Business', 'Business')}
                value={tabs[0].value}
                component={Link}
                to={tabs[0].route}
              />
              <Tab
                key="playlists"
                label={t('Business.Tabs.Playlists', 'Playlists')}
                value={tabs[1].value}
                component={Link}
                to={tabs[1].route}
              />
            </TabList>
          </TabContext>
        </Box>
      )}
      <Outlet />
    </>
  )
}

export default BusinessLayout
